/*@ngInject*/
const UIDragManagerDirective = function ($document, $rootScope, $timeout, formMediator, formViewerConstant) {

    let linkFunction = function ($scope, $elm, $attr) {

        let element = $($elm),
            selectionContainer = element.find('.selectionContainer'),
            rootFormId = $scope.componentStructure.rootFormId,
            isDraggable = $scope.componentStructure.parentForm.hasWriteAccess,
            parentFormName = $scope.componentStructure.parentFormStructure.formName,
            fieldStructureId = $scope.componentStructure.fieldStructureId,
            parentRowSelector = getParentRowSelectorFromFieldStructureId(fieldStructureId),
            isTopDropAttempt,
            isBottomDropAttempt,
            isLeftDropAttempt,
            isRightDropAttempt,
            isDraggingOverDropZone = false;

        if (isDraggable) {
            element.attr('draggable', 'true');
        }

        function getParentRowSelectorFromFieldStructureId(fieldStructureId) {
            return '.' + parentFormName + ' .rowEditor:has(.' + fieldStructureId + ')';
        }

        function selectThisField() {
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, $scope.componentStructure);
            $timeout(function () {}, 0);
        }

        function onMouseEnter() {
            selectionContainer.addClass('selectable');
            enableDebuggerTools();
        }

        function onMouseLeave() {
            selectionContainer.removeClass('selectable');

            isTopDropAttempt = false;
            isBottomDropAttempt = false;
            isLeftDropAttempt = false;
            isRightDropAttempt = false;

            onDragLeave();

            const debuggerInfo = {
                parentFormName: parentFormName,
                indexedName: $scope.componentStructure.indexedName,
                fieldStructureId: fieldStructureId,
                parentRowSelector: parentRowSelector
            };

            $rootScope.$broadcast(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT_END, debuggerInfo);
            disableDebuggerTools();
            $timeout(()=>{},0);
        }

        function onMouseMove (event) {
            let position,
                xVal,
                yVal,
                parentRow,
                height,
                width,
                horizontalMiddle;

            isTopDropAttempt = false;
            isBottomDropAttempt = false;
            isLeftDropAttempt = false;
            isRightDropAttempt = false;

            if(isDraggingOverDropZone) {
                parentRow = $(parentRowSelector);
                position = element.offset();
                xVal = event.clientX - position.left;
                yVal = event.clientY - position.top;

                height = element.height();
                width = element.width();
                horizontalMiddle = width / 2;
                isTopDropAttempt = yVal < 8;
                isBottomDropAttempt = yVal > (height - 8);
                isLeftDropAttempt = xVal < horizontalMiddle;
                isRightDropAttempt = xVal > horizontalMiddle;

                parentRow.removeClass('dragOverTop');
                parentRow.removeClass('dragOverBottom');
                element.removeClass('dragOverLeft');
                element.removeClass('dragOverRight');

                if (isTopDropAttempt) {
                    parentRow.addClass('dragOverTop');
                }
                else if (isBottomDropAttempt) {
                    parentRow.addClass('dragOverBottom');
                }
                else if (isLeftDropAttempt) {
                    element.addClass('dragOverLeft');
                }
                else if (isRightDropAttempt) {
                    element.addClass('dragOverRight');
                }

                const debuggerInfo = {
                    parentFormName: parentFormName,
                    indexedName: $scope.componentStructure.indexedName,
                    fieldStructureId: fieldStructureId,
                    parentRowSelector: parentRowSelector,
                    xValue: xVal,
                    yValue: yVal,
                    isTopDropAttempt :isTopDropAttempt,
                    isBottomDropAttempt: isBottomDropAttempt,
                    isLeftDropAttempt: isLeftDropAttempt,
                    isRightDropAttempt: isRightDropAttempt
                };

                $rootScope.$broadcast(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT, debuggerInfo);
                $timeout(()=>{},0);
            }
        }

        function onMouseUp() {
            selectThisField();
        }

        function onDragStart(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                isDraggingComponent = event.target.className.indexOf('componentEditor') !== -1,
                dragConfiguration = {
                    formStructureType: formViewerConstant.configuration.formStructureType.COMPONENT,
                    dragType: formViewerConstant.configuration.dragOperationType.MOVE,
                    fieldStructureId: $scope.componentStructure.fieldStructureId
                };

            selectThisField();
            if (isDraggingComponent) {
                element.addClass('dragging');
                dataTransfer.effectAllowed = 'move';
                event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
                formMediator.setCurrentDragItem(dragConfiguration);
            }
        }

        function onDragOver(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                currentDropTarget = $(event.currentTarget),
                isElementBeingDragged = currentDropTarget.hasClass('dragging'),
                currentDragConfig = formMediator.getCurrentDragItem(),
                isDraggingComponent = !_.isNil(currentDragConfig) && currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.COMPONENT;

            if (!isElementBeingDragged && isDraggingComponent) {
                isDraggingOverDropZone = true;
                dataTransfer.dropEffect = 'move';
                onMouseMove(event);
                event.preventDefault();
            }
        }

        function onDragLeave() {
            let parentRow = $(parentRowSelector);

            isDraggingOverDropZone = false;

            element.removeClass('dragOverLeft');
            element.removeClass('dragOverRight');
            parentRow.removeClass('dragOverTop');
            parentRow.removeClass('dragOverBottom');
        }

        function onDrop(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                dropConfiguration = JSON.parse(dataTransfer.getData('text')),
                isInsertDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.INSERT,
                isMoveDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.MOVE,
                currentDragConfig = formMediator.getCurrentDragItem(),
                isDraggingComponent = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.COMPONENT;

            if (isDraggingComponent) {
                if (isInsertDropOperation) {
                    handleInsertDropOperation($(event.currentTarget), dropConfiguration);
                } else if (isMoveDropOperation) {
                    handleMoveDropOperation($(event.currentTarget), dropConfiguration);
                }

                event.preventDefault();
                return false;
            }
        }

        function handleInsertDropOperation(dropZone, dropConfiguration) {
            let dropZoneFieldId = $scope.componentStructure.fieldStructureId,
                dropZoneParentRow = $(parentRowSelector),
                takeAction = isTopDropAttempt || isBottomDropAttempt || isLeftDropAttempt || isRightDropAttempt,
                moveActionResult,
                newComponentConfiguration,
                newRowConfiguration;

            if (takeAction) {
                if (isTopDropAttempt) {
                    dropConfiguration.dropType = formViewerConstant.configuration.INSERT_ABOVE;
                    moveActionResult = formMediator.createField(rootFormId, dropConfiguration, dropZoneFieldId);

                    formMediator.buildEmptyUiRowTemplate().then(function (result) {
                        moveActionResult.movedElement.rowTemplate = result;
                    });

                    newRowConfiguration = {
                        row: moveActionResult.movedElement,
                        dropZoneRow: dropZoneParentRow,
                        createAfterDropZone: false

                    };
                    $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW, newRowConfiguration);
                } else if (isBottomDropAttempt) {
                    dropConfiguration.dropType = formViewerConstant.configuration.INSERT_BELOW;
                    moveActionResult = formMediator.createField(rootFormId, dropConfiguration, dropZoneFieldId);

                    formMediator.buildEmptyUiRowTemplate().then(function (result) {
                        moveActionResult.movedElement.rowTemplate = result;
                    });

                    newRowConfiguration = {
                        row: moveActionResult.movedElement,
                        dropZoneRow: dropZoneParentRow,
                        createAfterDropZone: true

                    };
                    $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW, newRowConfiguration);
                } else if (isLeftDropAttempt) {
                    dropConfiguration.dropType = formViewerConstant.configuration.INSERT_BEFORE;
                    moveActionResult = formMediator.createField(rootFormId, dropConfiguration, dropZoneFieldId);

                    newComponentConfiguration = {
                        fieldStructure: moveActionResult.movedElement,
                        targetSibling: dropZone,
                        createAfterDropZone: false
                    };
                    $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, newComponentConfiguration);
                } else if (isRightDropAttempt) {
                    dropConfiguration.dropType = formViewerConstant.configuration.INSERT_AFTER;
                    moveActionResult = formMediator.createField(rootFormId, dropConfiguration, dropZoneFieldId);

                    newComponentConfiguration = {
                        fieldStructure: moveActionResult.movedElement,
                        targetSibling: dropZone,
                        createAfterDropZone: true,
                        isRowRepeater: moveActionResult.isRowRepeater
                    };
                    $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, newComponentConfiguration);
                }
            }

            dropZoneParentRow.removeClass('dragOverTop');
            dropZoneParentRow.removeClass('dragOverBottom');
            dropZone.removeClass('dragOverLeft');
            dropZone.removeClass('dragOverRight');
        }

        function handleMoveDropOperation(dropZone, dropConfiguration) {
            let elementToMoveId,
                elementToMoveSelector,
                elementToMove,
                elementToMoveParentRow,
                dropZoneFieldId,
                dropZoneParentRow,
                takeAction,
                moveActionResult,
                newRowConfiguration,
                currentDragConfig = formMediator.getCurrentDragItem(),
                isDraggingComponent = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.COMPONENT;

            if (isDraggingComponent) {
                elementToMoveId = dropConfiguration.fieldStructureId;
                elementToMoveSelector = '.' + elementToMoveId;
                dropZoneFieldId = $scope.componentStructure.fieldStructureId;
                dropZoneParentRow = $(parentRowSelector);
                takeAction = isTopDropAttempt || isBottomDropAttempt || isLeftDropAttempt || isRightDropAttempt;

                if (takeAction) {
                    elementToMoveParentRow = $(getParentRowSelectorFromFieldStructureId(dropConfiguration.fieldStructureId));
                    elementToMove = $(elementToMoveSelector).detach();
                    elementToMove.removeClass('dragging');
                }

                dropZoneParentRow.removeClass('dragOverTop');
                dropZoneParentRow.removeClass('dragOverBottom');
                dropZone.removeClass('dragOverLeft');
                dropZone.removeClass('dragOverRight');

                if (takeAction) {
                    if (isTopDropAttempt) {
                        moveActionResult = formMediator.moveField(rootFormId, elementToMoveId, dropZoneFieldId, formViewerConstant.configuration.INSERT_ABOVE);

                        formMediator.buildEmptyUiRowTemplate().then(function (result) {
                            moveActionResult.movedElement.rowTemplate = result;
                        });

                        newRowConfiguration = {
                            row: moveActionResult.movedElement,
                            dropZoneRow: dropZoneParentRow,
                            createAfterDropZone: false

                        };
                        $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW, newRowConfiguration);
                    } else if (isBottomDropAttempt) {
                        moveActionResult = formMediator.moveField(rootFormId, elementToMoveId, dropZoneFieldId, formViewerConstant.configuration.INSERT_BELOW);

                        formMediator.buildEmptyUiRowTemplate().then(function (result) {
                            moveActionResult.movedElement.rowTemplate = result;
                        });

                        newRowConfiguration = {
                            row: moveActionResult.movedElement,
                            dropZoneRow: dropZoneParentRow,
                            createAfterDropZone: true

                        };
                        $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW, newRowConfiguration);
                    } else if (isLeftDropAttempt) {
                        moveActionResult = formMediator.moveField(rootFormId, elementToMoveId, dropZoneFieldId, formViewerConstant.configuration.INSERT_BEFORE);
                        elementToMove.insertBefore(dropZone);
                    } else if (isRightDropAttempt) {
                        moveActionResult = formMediator.moveField(rootFormId, elementToMoveId, dropZoneFieldId, formViewerConstant.configuration.INSERT_AFTER);
                        elementToMove.insertAfter(dropZone);
                    }

                    if (moveActionResult.removePreviousRow) {
                        elementToMoveParentRow.remove();
                    }
                }
            }
        }

        function onDragEnd() {
            element.removeClass('dragging');
            element.removeClass('dragOverLeft');
            element.removeClass('dragOverRight');
            isDraggingOverDropZone = false;
            selectThisField();
        }

        function enableDebuggerTools() {
            if(isDebuggingDragAndDrop()) {
                isDraggingOverDropZone = true;
            }
        }

        function disableDebuggerTools() {
            if(isDebuggingDragAndDrop()) {
                isDraggingOverDropZone = false;
            }
        }

        function isDebuggingDragAndDrop () {
            const form = $('.formViewer:has(.' + parentFormName + ')');
            return form.hasClass('debugDragAndDrop');
        }

        element.on('mouseup', onMouseUp);
        element.on('mouseenter', onMouseEnter);
        element.on('mouseleave', onMouseLeave);
        element.on('mousemove', onMouseMove);

        if (isDraggable) {
            element.on('dragstart', onDragStart);
            element.on('dragover', onDragOver);
            element.on('dragleave', onDragLeave);
            element.on('drop', onDrop);
            element.on('dragend', onDragEnd);
        }

        $scope.$on(formViewerConstant.configuration.event.DELETE_FIELD, function (event, fieldStructureId) {
            if ($scope.componentStructure.fieldStructureId === fieldStructureId) {
                $scope.resetComponent(element.parent(), fieldStructureId);
            }
        });

        $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
            element.attr('draggable', 'false');
        });

        $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
            element.attr('draggable', 'true');
        });

        $scope.$on('$destroy', function () {
            element.off('mouseenter', onMouseEnter);
            element.off('mouseleave', onMouseLeave);
            element.off('mousemove', onMouseMove);
            element.off('mouseup', onMouseUp);
            element.off('dragstart', onDragStart);
            element.off('dragover', onDragOver);
            element.off('dragleave', onDragLeave);
            element.off('drop', onDrop);
            element.off('dragend', onDragEnd);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umFormViewer')
    .directive('uiDragManager', UIDragManagerDirective);
